import axios from 'axios'
import { storeAllEntities } from '@/helpers/store'

export default {
  state: {
    courses: {},
  },
  mutations: {},
  actions: {
    getCourseSubscribables ({ commit, state }, { courseId }) {
      return axios.get(`/employee/courses/${courseId}/subscribables/api`).then(storeAllEntities(commit))
    },
  },
  getters: {},
}
